// src/api/endpoints/auth.js
import api from "../configs/axios.config";

export const authEndpoints = {
  login: (credentials) => api.post("/auth/signin", credentials),
  register: (data) => api.post("/auth/signup", data),
  logout: () => api.post("/auth/signout"),
};
